import { Container, useMediaQuery, useTheme } from "@mui/material";
import { ErrorPanel } from "@qubit/autoparts";
import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { NoOrders } from "~/features/orders/NoOrders";

import { getMessageFromRtkError } from "~/lib/rtkErrorToMessage";
import { FulfillmentCenterDto, OrderSummaryDto } from "~/types/api";

import { OrderTable as OrderTableV1 } from "./OrderTable";
import { OrderTableV2 } from "./OrderTableV2";

export type OrderTableWrapperProps = {
  formatOrderStatus?: (order: OrderSummaryDto) => string;
  fulfillmentCenter: FulfillmentCenterDto | null;
  onOrderSelected: (order: OrderSummaryDto) => void;
  orders: OrderSummaryDto[];
  ordersLoading: boolean;
  selectedDate: Date | null;
  selectedOrderIds: Guid[];
  title: string;
  ordersError?: FetchBaseQueryError | SerializedError;
  handleDateChange: (date: Date | null) => void;
  hasOrdersV2EnhancedFlag?: boolean;
};

export function OrderTableWrapper(props: OrderTableWrapperProps) {
  const { orders, ordersLoading, ordersError, hasOrdersV2EnhancedFlag } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const noOrders =
    !ordersLoading && orders && orders.length === 0 && !ordersError;

  // V2 Implementation with LD flag
  if (hasOrdersV2EnhancedFlag) {
    return (
      <Container
        sx={{ p: 2, ...(isMobile && { height: "100%", overflow: "hidden" }) }}
      >
        {!!ordersError && (
          <ErrorPanel message={getMessageFromRtkError(ordersError)} />
        )}
        {!ordersError && <OrderTableV2 {...props} />}
      </Container>
    );
  }

  return (
    <Container sx={{ p: 4 }}>
      {!!ordersError && (
        <ErrorPanel message={getMessageFromRtkError(ordersError)} />
      )}
      {!ordersError && (noOrders ? <NoOrders /> : <OrderTableV1 {...props} />)}
    </Container>
  );
}

export default OrderTableWrapper;
